import * as React from 'react';
import * as ReactDOM from 'react-dom/client';
import Pager from '../_common/pager';

const productData = [
  {
    type: 'fap',
    img: '/images/newProduct/fap.png'
  },
  {
    type: 'cmp',
    img: '/images/newProduct/cmp.png'
  },
  {
    type: 'wl',
    img: '/images/newProduct/wl.png'
  },
  {
    type: 'dr',
    img: '/images/newProduct/dr.png'
  }
]

const productType = window.location.search.split('?')[1]
console.log(productType, '====== productType', productType)

const PagesBody = props => {
  return (
    <div className='imgbody'>
      {
        productData.map(item => {
          return (
            <img
              key={item.type}
              id={`product-${item.type}`}
              src={item.img} />
          )
        })
      }
    </div>

  )
}

const App = (props) => {
  React.useEffect(() => {
    if (!productType) return

    const timer = setTimeout(() => {
      const el = document.getElementById(`product-${productType}`)
      if (el) {
        el.scrollIntoView({
          behavior: 'smooth', // 平滑滚动
          block: 'start'
        })
      }
    }, 50);
    return () => clearTimeout(timer)
  }, [])
  const data = productData.filter(item => item.type === productType)[0]
  const cfg = {
    body: <PagesBody {...data} />,
  }
  return <Pager {...cfg} />
}

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<App />)